import { useNavigate, useLocation } from 'react-router-dom'
import { useParams } from 'react-router'

import { Tabs, TabsList, TabsTrigger } from '~/components/ui/Tabs'

interface ChangesSubmittalsTabsProps {
  defaultTab: 'changes' | 'submittals'
}

export default function ChangesSubmittalsTabs({
  defaultTab
}: ChangesSubmittalsTabsProps) {
  const location = useLocation()
  const navigate = useNavigate()
  const { orgId, projectId } = useParams<{ orgId: string; projectId: string }>()

  const isProcore = location.pathname.startsWith('/procore') ? '/procore' : ''

  return (
    <Tabs defaultValue={defaultTab} className="w-full">
      <TabsList className="grid w-full grid-cols-2">
        <TabsTrigger
          value="changes"
          onClick={() =>
            navigate(`${isProcore}/org/${orgId}/project/${projectId}/reviews`)
          }
        >
          Changes
        </TabsTrigger>
        <TabsTrigger
          value="submittals"
          onClick={() =>
            navigate(`${isProcore}/org/${orgId}/project/${projectId}/submittals`)
          }
        >
          Submittals
        </TabsTrigger>
      </TabsList>
    </Tabs>
  )
}
